import request from '@/utils/request'

export default {
  /**
   * 获取今日我的收款记录
   */
  getMyTodayCustomerPrepaymentPayRecords(params) {
    return request.get('/customer-prepayment-pay-records/mine/today', { params })
  }
}
